import React, { Component } from "react";
import { connect } from "react-redux";
import {MAIN_SECTION} from "../../styles";
import Header from "../../common/components/Header";
import { loadUptakeReportData, columnSorted } from "./reportingActions";
import moment from "moment";
import { Table, Tr, Td, Th, Thead } from "reactable";
import DemoModeTag from "../components/DemoModeTag";

export const Stat = (props) =>
    <div style={{float: "left", width: "15em", margin: "1em"}}>
        <div className={props.className} style={{fontSize: "xx-large", display:"inline-block", verticalAlign: "top"}}>{props.value}</div>
        <div style={{display:"inline-block", width: "8em", marginLeft: "1em"}}>{props.label}</div>
    </div>;

const headerStyle = {
    fontWeight: "normal",
    color: "#888",
    padding: "0.5em 1em",
    MozUserSelect: "none",
    WebkitUserSelect: "none",
    msUserSelect: "none",
    userSelect: "none",
    textAlign: "left"
};
const cellStyle = {
    padding: "0.5em 1em"
};

const infoTipStyle = {
    backgroundColor: "#888",
    borderRadius: "50%",
    display: "inline-block",
    width: "1em",
    height: "1em",
    textAlign: "center",
    color: "white",
    padding: "0.15em",
    fontSize: "10px",
    lineHeight: "1em"
};

const sortHeaderStyleFor = () => {
    return { backgroundColor: "#EEE" };
};

const directionFor = (numericDirection) => (numericDirection < 0) ? "desc" : "asc";

export class UptakeReport extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadData()
    }

    getHeaderStyleFor(column) {
        if (this.props.sort.column == column) {
            return Object.assign({}, headerStyle, sortHeaderStyleFor(this.props.sort.direction));
        }

        return headerStyle;
    }

    getCellStyleFor(column) {
        if (this.props.sort.column == column) {
            return Object.assign({}, cellStyle, { backgroundColor: "#EEE"})
        }

        else return cellStyle;
    }

    report() {

        return <div style={{fontSize: "14px"}}>
            <div className="clearfix">
                <Stat value={this.props.registeredCount} className="x-registered-count" label="Users registered to record communications"/>
                <Stat value={this.props.activeCount} className="x-active-count" label="Active in last 7 days"/>
            </div>
            <div style={{paddingTop: "1em", borderTop: "1px solid #eee", marginBottom: "0"}}>
                <span style={{display: "inline-block", marginBottom: 0,  marginLeft: "14em", color: "#888"}}>
                    Recommendations recorded
                </span>
                <span style={{display: "inline-block", marginBottom: 0, marginLeft: "9em", color: "#888"}}>
                    Communications recorded
                    <div style={Object.assign({}, infoTipStyle, {marginLeft: "0.5em", position: "relative", top: "-2"})} className="tooltip">
                        ?
                        <div className="tooltip-text" style={{width: "27em", fontSize: "13px", marginLeft: "-10em"}}>A communication consists of one or more recommendations</div>
                    </div>
                </span>
            </div>
            <Table style={{width: "80%", marginTop: "0.3em"}}
                   sortable={true}
                   defaultSort={{ column: this.props.sort.column, direction: directionFor(this.props.sort.direction)}}
                   onSort={this.props.columnSorted}>
                <Thead>
                    <Th column="name"
                        className="x-name-header"
                        style={this.getHeaderStyleFor("name")}>Name</Th>
                    <Th column="recommendations-last-seven-days"
                        style={this.getHeaderStyleFor("recommendations-last-seven-days")}>
                        Last 7 days
                    </Th>
                    <Th column="recommendations-since-inception"
                        style={this.getHeaderStyleFor("recommendations-since-inception")}>All time</Th>
                    <Th column="communications-last-seven-days"
                        style={this.getHeaderStyleFor("communications-last-seven-days")}>Last 7 days</Th>
                    <Th column="communications-since-inception"
                        style={this.getHeaderStyleFor("communications-since-inception")}>All time</Th>
                    <Th column="last-communications-timestamp"
                        style={this.getHeaderStyleFor("last-communications-timestamp")}>Last Communication</Th>
                </Thead>
                { this.props.users.map(user =>
                    <Tr key={user.communicatorId}>
                        <Td column="name" style={Object.assign(this.getCellStyleFor("name"), {width: "14em"})} value={user.name}>
                            <span className="x-user-name">
                                { user.name }
                                { user.inDemoMode
                                    ? <DemoModeTag style={{ width: "4.9em", marginTop: "0.1em" }}>demo user</DemoModeTag>
                                    : undefined }
                            </span>
                        </Td>
                        <Td column="recommendations-last-seven-days"
                            style={this.getCellStyleFor("recommendations-last-seven-days")}
                            value={user.recommendationsLastSevenDays}>
                            <span className="x-user-recommendations-last-seven-days">{user.recommendationsLastSevenDays}</span>
                        </Td>
                        <Td column="recommendations-since-inception"
                            style={this.getCellStyleFor("recommendations-since-inception")}
                            value={user.recommendationsSinceInception}>
                            <span className="x-user-recommendations-since-inception">{user.recommendationsSinceInception}</span>
                        </Td>
                        <Td column="communications-last-seven-days"
                            style={this.getCellStyleFor("communications-last-seven-days")}
                            value={user.communicationsLastSevenDays}>
                            <span className="x-user-communications-last-seven-days">{user.communicationsLastSevenDays}</span>
                        </Td>
                        <Td column="communications-since-inception"
                            style={this.getCellStyleFor("communications-since-inception")}
                            value={user.communicationsSinceInception}>
                            <span className="x-user-communications-since-inception">{user.communicationsSinceInception}</span>
                        </Td>
                        <Td column="last-communications-timestamp"
                            style={this.getCellStyleFor("last-communications-timestamp")}
                            value={user.lastCommunicationTimestamp === null ? -Infinity : moment(user.lastCommunicationTimestamp)}>
                            <span className="x-user-last-communications-timestamp">
                                { user.lastCommunicationTimestamp === null ? "Never" : moment(user.lastCommunicationTimestamp).format("MMM D, YYYY h:mma") }
                            </span>
                        </Td>
                    </Tr>
                )}
            </Table>
        </div>;
    }

    render() {
        return <div style={Object.assign({}, MAIN_SECTION, {width: "1200px", margin: "1em auto"})}>
            <Header>
                Uptake Report
                <span style={{float: "right", fontWeight: "normal", fontSize: "14px", color: "#888"}}>Trade Ideas excluded</span>
            </Header>
            { this.props.loaded ? this.report() : "Loading..." }
        </div>;
    }
}
UptakeReport.propTypes = {
    loadData: React.PropTypes.func.isRequired
};


export const mapStateToProps = (state) => (state.reporting.uptake && {
    registeredCount:  state.reporting.uptake.length,
    activeCount: state.reporting.uptake.filter(user => user.communicationsLastSevenDays !== 0).length,
    users: state.reporting.uptake,
    loaded: true,
    sort: {
        column: state.reporting.sort.column || "communications-last-seven-days",
        direction: state.reporting.sort.direction || -1
    }
} || {});

export const mapDispatchToProps = (dispatch, ownProps) => ({
    loadData: () => {
        dispatch(loadUptakeReportData());
    },
    columnSorted: (payload) => {
        dispatch(columnSorted(payload))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(UptakeReport);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/uptake/UptakeReport.js
 **/